import { app } from '../../../app';
import { Controller } from './domains.controller';

app.component('companyDomains', {
    bindings: {domains: '<'},
    controller: Controller,
    templateUrl : require('./domains.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/domains/domains.component.js